import { render, staticRenderFns } from "./uploadLetterPage.vue?vue&type=template&id=1d05f8b0&"
import script from "./uploadLetterPage.vue?vue&type=script&lang=js&"
export * from "./uploadLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadLetterPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports